import React from "react"  


const Loader = () => {
    return(
       <div style={{backgroundColor: "white", width: "100vh"}} >
        <img 
        className="loader"
        src="loader2.gif" 
        alt="Myloader"/>   
       </div>
    )
} 


export default Loader;